import { Divider, Grid, Paper, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useFieldArray, useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { callAPI, compressImageFile, customValidation, EPhone, formatPhoneNumber, Method, validations } from "../../commonFunctions/CommonFunctions";
import http from "../../commonFunctions/httpClient";
import { WSIcons } from "../../commonFunctions/iIcons";
import WSImageUpload from "../../Components/FileUpload/WSImageUpload";
import { HeaderList, IHeaderListActions } from "../../Components/Header/HeaderList";
import WSPhone from "../../Components/Phone/WSPhone";
import WSSelectField from "../../Components/Select/WSSelect";
import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";
import WSTextField from "../../Components/TextBox/WSTextBox";
import { WSHeaderCard } from "../../Components/View/HeaderCard";
import config from '../../Config/config.json';
const VendorProfileEdit: React.FC<any> = React.memo((props) => {
    const { showMessage } = useSnackbar();
    const { register, handleSubmit, control, setValue, watch, reset, getValues } = useForm();
    const navigate = useNavigate();
    const params = useParams();
    const [imageUrl, setImageUrl] = useState<any>([]);
    const [VendorData, setVendorData] = useState<any>(null)
    const [loading, setLoading] = useState<boolean>(false);
    const [loaded, setloaded] = useState<boolean>(true);
    const [userData, setUserData] = useState<any>(null)
    const id: any = params?.userId;
    // const VendorUserId: any = params?.userId;
    const [selectedFile, setSelectedFile] = useState<File | null>(null);
    // const [selectedDocuments, setSelectedDocuments] = useState<File | null>(null);
    const { fields, append, remove, replace } = useFieldArray({
        name: "items",
        control
    });
    useEffect(() => () => {
        reset()
    }, [])

    useEffect(() => {
        append({
            startTime: "",
            endTime: "",
            day: "",
        })
    }, [])

    // useEffect(() => {
    //     /**
    //      * Method to get the user record by id for edit purpose
    //      * @param id 
    //      */

    //     async function getUserById(): Promise<void> {
    //         try {
    //             const response: any = await http.get(`Auth/${VendorUserId}`)
    //             if (response) {
    //                 setUserData(response)
    //                 for (const field in response) {
    //                     if (field === 'phoneNumber') {
    //                         setValue(field, formatPhoneNumber((response as any)[field], EPhone.AddHyphen))
    //                     }

    //                     else {
    //                         setValue(field, (response as any)[field]);
    //                     }
    //                 }
    //                 setValue('name', response?.name);
    //             }
    //         } catch (error) {
    //             showMessage('Error fetching user:', 'error');
    //         }
    //     }
    //     if (VendorUserId) {
    //         getUserById();
    //     }
    // }, [VendorUserId]);
    const vendorTypeSouse = {
        url: "VendorTypeMaster/search",
        page: 1,
        pageSize: 100000,
        filter: [],
        sort: [],
    };
    const vendorServiceSource = {
        url: "VendorService/search",
        page: 1,
        pageSize: 100000,
        filter: [],
        sort: [],
    };
    const serviceSource = {
        url: "VendorService/search",
        page: 1,
        pageSize: 10,
        filter: [],
        sort: [],
    };
    useEffect(() => {
        /**
         * Method to get the user record by id for edit purpose
         * @param id 
         */
        async function getVendorById(id: any): Promise<void> {
            try {
                setloaded(false)
                const response: any = await http.get(`VendorProfile/User/${id}`)  //callAPI
                if (response && response.data) {
                    setVendorData(response.data)
                    setValue("userId", id);
                    setValue("name", response?.data.name);
                    setValue("vendorTypeId", response?.data?.vendorTypeId);
                    setValue("phoneNumber", formatPhoneNumber(response?.data?.phoneNumber, EPhone.RemoveHyphen));
                    setValue("companyName", response?.data.companyName);
                    setValue("email", response?.data?.email);
                    setValue("licenceNumber", response?.data?.licenceNumber);
                    setValue("GSTNumber", response?.data?.gstNumber);
                    setValue("panNumber", response?.data?.panNumber);
                    setValue("addressLine1", response?.data.addressLine1);
                    setValue("addressLine2", response?.data?.addressLine2);
                    setValue("state", response?.data.state);
                    setValue("city", response?.data.city);
                    setValue("pincode", response?.data.pincode);
                    setValue("websiteUrl", response?.data?.websiteUrl);
                    if (response?.data?.profileImageUrl) {
                        setImageUrl(`${config.imgUrl}${response?.data?.profileImageUrl.replace("UploadedImages/", "")}`)
                    }
                    //     for (const field in response.data) {
                    //         if (field === 'phoneNumber') {
                    //             setValue(field, formatPhoneNumber((response?.data as any)[field], EPhone.AddHyphen))
                    //         }
                    //         else if (field === 'profileImageUrl') {
                    //             setImageUrl(`${config.imgUrl}${response?.data[field].replace("UploadedImages/", "")}`)
                    //         }
                    //         else {
                    //             setValue(field, (response?.data as any)[field]);
                    //         }
                    //     }
                    //     setValue('GSTNumber', response.data?.gstNumber)

                }



            } catch (error) {
                showMessage('Error fetching vendor:', 'error');
            }
        }
        if (id) {
            getVendorById(id);
        }
    }, [id]);

    const handleCancelClick = () => {
        navigate(`/`);
    };
    const handleUploadChange = async (uploadedFile: any) => {
        const file: any = uploadedFile[0];
        try {


            let newFile: any = await compressImageFile(uploadedFile);
            setSelectedFile(newFile)

        } catch (error) {
            showMessage("Error converting file to base64:", 'error');
        }
    }

    /**
     * Method for Add/Update the data
     * @param data 
     */
    const onSubmit = async (data: any) => {
        try {
            setLoading(true)
            const request: any = await setRequest(data);
            if (id && VendorData?.id) {
                const response: any = await callAPI(`VendorProfile/${VendorData?.id}`, Method.PUTFORMDATA, null, null, request);
                if (response) {
                    if (response.success === true) {
                        showMessage(response?.message, response.success === true ? "success" : "error");
                        response.success === true && navigate(`/`);
                    }
                }
            }
        } catch (e: any) {
            showMessage(e.error);
        }
        finally {
            setLoading(false)
        }
    };



    const setRequest = async (data: any) => {
        try {


            const formData = new FormData()
            if (selectedFile) {
                formData.append("profileImage", selectedFile!);
            }
            // if (selectedDocuments) {
            //     formData.append("documents", selectedDocuments!);
            // }
            formData.append("userId", id);
            formData.append("name", data.name);
            formData.append("VendorTypeId", data?.vendorTypeId);
            formData.append("phoneNumber", formatPhoneNumber(data?.phoneNumber, EPhone.RemoveHyphen));
            formData.append("companyName", data.companyName);
            formData.append("email", data?.email);
            formData.append("licenceNumber", data?.licenceNumber);
            formData.append("GSTNumber", data?.GSTNumber);
            formData.append("panNumber", data?.panNumber);
            formData.append("addressLine1", data.addressLine1);
            formData.append("addressLine2", data?.addressLine2);
            formData.append("state", data.state);
            formData.append("city", data.city);
            formData.append("pincode", data.pincode);
            formData.append("websiteUrl", data?.websiteUrl);



            return formData
        } catch (e: any) {
            showMessage(e.error);
        }
    };
    const actions: IHeaderListActions[] =
        [
            { type: 'button', text: 'Cancel', size: 'small', onClick: handleCancelClick, variant: 'outlined', color: 'primary' },
            { type: 'button', text: 'Save', size: 'small', loading: loading, buttonType: 'submit', variant: 'outlined', color: 'primary' }
        ]


    const transFormDataVendorType = (data: any) => {
        const qualifications: Array<any> = []
        if (data) {
            data.map((item: any) => {
                qualifications.push({ label: item.typeName, value: item.id })
            })
        }
        return qualifications;
    }

    // const handleUploadFile = (file: any) => {
    //     // setDefaultImg(null)
    //     if (file && file.length > 0) {
    //         setSelectedDocuments(file);
    //     }
    // }
    return (
        <>
            <form onSubmit={handleSubmit(onSubmit)}>
                <HeaderList title={!id ? "Add Vendor" : "Update Vendor"} isBackButton={true} url="/" type="card" actions={actions} isDivider headerSx={{ height: 50 }} />

                <Paper elevation={3} style={{ paddingLeft: 20, paddingRight: 20, marginTop: 0, paddingBottom: 25, border: '1px solid #ccc', borderRadius: '8px' }}>


                    <Grid xs={12} container spacing={2} style={{ marginTop: 10 }}>
                        <Grid item sm={12} xs={12}>
                            <WSHeaderCard header="Profile" backGroundColor="#DDF2EBCC" />
                        </Grid>

                        <Grid item sm={4} xs={12}>
                            <Grid container alignItems="center" spacing={2}>
                                {/* Image Upload - left side */}
                                <Grid item>
                                    <WSImageUpload
                                        control={control}
                                        id="profileImage"
                                        name="profileImage"
                                        label="Profile Image"
                                        rules={{ required: false }}
                                        onChange={handleUploadChange}
                                        imgUrl={imageUrl}
                                    />
                                </Grid>

                                {/* Name - right side, vertically centered */}
                                <Grid item sx={{ mt: 2 }}>
                                    <Typography sx={{ fontSize: '0.875rem', color: 'gray' }}>
                                        {VendorData?.name}
                                    </Typography>
                                </Grid>
                            </Grid>

                        </Grid>
                        {VendorData && < Grid item sm={8} xs={12}>
                            <Grid item container spacing={1} alignItems="center">
                                <Grid item>
                                    <WSIcons.PhoneIcon sx={{ fontSize: '0.875rem', mt: 1 }} />
                                </Grid>
                                <Grid item>
                                    <Typography sx={{ fontSize: '0.875rem', color: 'gray' }}>
                                        {VendorData?.phoneNumber}
                                    </Typography>
                                </Grid>
                            </Grid>
                            <Grid item container spacing={1} alignItems="center">
                                <Grid item>
                                    <WSIcons.EmailIcon sx={{ fontSize: '0.875rem', mt: 1 }} />
                                </Grid>
                                <Grid item>
                                    <Typography sx={{ fontSize: '0.875rem', color: 'gray' }}>
                                        {VendorData?.email ? VendorData?.email : '-'}
                                    </Typography>
                                </Grid>
                            </Grid>

                        </Grid>
                        }
                        <Grid item sm={12} xs={12}>
                            <Divider />
                        </Grid>
                        <Grid item sm={12} xs={12}>
                            <WSHeaderCard header="Basic Information" backGroundColor="#DDF2EBCC" />
                        </Grid>
                        <Grid item sm={6} xs={12}>
                            <WSSelectField
                                rules={{ required: true }}
                                {...register("vendorTypeId")}
                                id="vendorTypeId"
                                control={control}
                                source={vendorTypeSouse}
                                transFormData={transFormDataVendorType}
                                label="Vendor Type"
                                name="vendorTypeId"
                            // multiple={true}
                            />
                        </Grid>
                        <Grid item sm={6} xs={12}>
                            <WSTextField control={control} id="companyName" name="companyName" rules={{ required: true }} label="Company Name *"></WSTextField>

                        </Grid>
                        <Grid item sm={6} xs={12}>
                            <WSTextField control={control} id="licenceNumber" name="licenceNumber" rules={{ required: true }} label="Licence Number "></WSTextField>

                        </Grid>

                        <Grid item sm={6} xs={12}>
                            <WSTextField control={control} id="GSTNumber" name="GSTNumber" rules={{ required: true }} label="GST Number "></WSTextField>

                        </Grid>
                        <Grid item sm={6} xs={12}>
                            <WSTextField control={control} id="panNumber" name="panNumber" rules={{ required: true }} label="Pan Number "></WSTextField>

                        </Grid>
                        <Grid item sm={6} xs={12}>
                            <WSTextField control={control} id="websiteUrl" name="websiteUrl" rules={{ required: true }} label="Website Url "></WSTextField>

                        </Grid>

                        {/* <Grid item sm={6} xs={12}>
                            <WSTextField disabled control={control} id="name" name="name" rules={{ required: true }} label="Name *"></WSTextField>

                        </Grid>
                        <Grid item sm={6} xs={12}>
                            <WSTextField control={control} id="email" {...register('email')} name="email" rules={customValidation(true, validations.email)} label="Email *" disabled></WSTextField>
                        </Grid>
                        <Grid item sm={6} xs={12}>
                            <WSPhone label="Phone" rules={{ required: true }} control={control} id="phoneNumber" {...register('phoneNumber')} name="phoneNumber" disabled></WSPhone>
                        </Grid> */}


                        <Grid item sm={12} xs={12}>
                            <WSHeaderCard header="Address Information" backGroundColor="#DDF2EBCC" />

                        </Grid>
                        <Grid item sm={6} xs={12}>
                            <WSTextField control={control} id="addressLine1" name="addressLine1" rules={{ required: true }} label="Address Line1 *"></WSTextField>
                        </Grid>
                        <Grid item sm={6} xs={12}>
                            <WSTextField control={control} id="addressLine2" name="addressLine2" rules={{ required: false }} label="Address Line2 "></WSTextField>
                        </Grid>
                        <Grid item sm={6} xs={12}>
                            <WSTextField control={control} id="state" name="state" rules={{ required: true }} label="State *"></WSTextField>
                        </Grid>
                        <Grid item sm={6} xs={12}>
                            <WSTextField control={control} id="city" name="city" rules={{ required: true }} label="City *"></WSTextField>
                        </Grid>
                        <Grid item sm={6} xs={12}>
                            <WSTextField control={control} id="pincode" name="pincode" rules={{ required: true }} label="Pincode *" maxLength={6}></WSTextField>
                        </Grid>
                        {/* <Grid item sm={12} xs={12}>
                            <WSHeaderCard header="Additional Information" backGroundColor="#DDF2EBCC" />

                        </Grid> */}

                        {/* <Grid item sm={12} xs={12}>
                            <WSHeaderCard header="Attachemets" backGroundColor="#DDF2EBCC" />
                        </Grid>
                        <Grid item sm={12} style={{ overflow: 'auto' }}>
                            <WSFileUpload
                                name="documents"
                                label="Documents"
                                control={control}
                                rules={{ required: false }}
                                acceptFileTypes=".jpg,.jpeg,.png,.pdf,.docx"
                                maxFileSizeMB={2}
                                //  defaultValue={defaultImg}
                                id={"documents"}
                                image={true}
                                onChange={handleUploadFile}
                                // onRemove={handleRemove}
                                align="Start"
                                isToolTipImg={false}
                                multiple={true}
                            />
                        </Grid> */}

                    </Grid>
                </Paper>
            </form >









        </>
    );
});

export default VendorProfileEdit;